module.exports = __webpack_public_path__ + "img/Thumbnail_ZWF_Jan_Gorczak.ed1e3b9f.jpg";